module.exports = __webpack_public_path__ + "static/media/[TILT].5a91559c.svg";